import React from 'react'
import { connect } from 'react-redux'

import { newUserSelector } from 'selectors'

import Spinner from 'components/Spinner'
import Router from 'Router'
import Onboarding from 'pages/Onboarding'

const App = ({ pending, newUser }) => {
  if (pending) return <Spinner />
  if (newUser) return <Onboarding />
  return <Router />
}

const mapStateToProps = state => ({
  pending: state.auth.pending,
  newUser: newUserSelector(state),
})

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js